// const serviceCards = [
//   {
//     id: 1,
//     title: "Clarity in Every Trade",
//     description:
//       " We believe understanding the market is the first step to mastering it. Our platform is built to make every trade clear and every decision informed.",
//   },
//   {
//     id: 2,
//     title: "Trust Through Transparency",
//     description:
//       "Integrity is at the heart of everything we do, from our pricing to our policies. We strive to earn and maintain your trust through every interaction.",
//   },
//   {
//     id: 3,
//     title: "Empowerment Through Education",
//     description:
//       "We’re passionate about helping beginners transform into confident traders. Learning is not just an option at The Pips, it’s our foundation.",
//   },
//   {
//     id: 4,
//     title: "Innovation That Inspires",
//     description:
//       "We embrace technology that makes trading smarter, safer, and more intuitive, ensuring every trader has the tools to succeed.",
//   },
//   {
//     id: 5,
//     title: "Community That Connects",
//     description:
//       "Behind every trade is a human story. We’re proud to build a community where support, growth, and collaboration thrive.",
//   },
//   {
//     id: 6,
//     title: "Excellence Through Experience",
//     description:
//       "We continuously refine our platform and services through real market insights and user feedback, ensuring that every trader, beginner or expert, experiences the highest standard of performance, reliability, and support.",
//   },
// ];
import TopicThree from "./TopicThree";

const IndicesMarketContentThree = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      {/* <TopicThree /> */}

      <div className="how__work__market">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why The Pips</h1>
            <p>
              At The Pips, we’re redefining the trading experience with
              technology, transparency, and trust at the core. Whether you’re a
              seasoned trader or just getting started, our platform empowers you
              to trade smarter, faster, and with complete confidence. Every
              feature, from execution speed to market access, is designed to
              help you stay ahead of the curve.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Institutional-Grade Technology</h4>
                </div>
                <p>
                  {/* Trade on a platform built for precision and speed. The Pips
                  leverages cutting-edge infrastructure with ultra-low latency
                  execution, ensuring that your orders are filled at the best
                  available prices, even during peak market volatility. */}
                  Trade with ultra-fast execution and precision, even in
                  volatile markets.
                </p>
              </div>
            </div>

            {/* Email Inquiries */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Transparent and Fair Conditions</h4>
                </div>
                <p>
                  {/* We believe in clarity, not complexity. With no hidden fees,
                  real-time pricing, and tight spreads across all asset classes,
                  The Pips offers a truly level playing field for every trader.
                  What you see is exactly what you trade. */}
                  Enjoy real-time pricing, no hidden fees, and consistently
                  tight spreads.
                </p>
              </div>
            </div>

            {/* Our Office */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Intelligent Support and Insights</h4>
                </div>
                <p>
                  {/* Get more than just a trading platform, gain a partner in your
                  trading journey. Our expert support team and integrated market
                  insights provide real-time guidance, analysis, and educational
                  resources to help you make informed decisions confidently. */}
                  Get expert support and real-time insights to guide your
                  trading decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndicesMarketContentThree;
